import { createActions, createReducer } from 'reduxsauce'

import AnexosDetalhesPrestacaoService from '../../servicos/ArquivosAnexosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAnexosDetalhesPrestacaoInicio: [],
    buscaAnexosDetalhesPrestacaoSucesso: ['anexosDetalhesPrestacao'],
    buscaAnexosDetalhesPrestacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAnexosDetalhesPrestacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAnexosDetalhesPrestacaoInicio())
        let serv = new AnexosDetalhesPrestacaoService()
        return serv
            .consultarAnexosDetalhesPrestacao(filtro)
            .then(response => dispatch(Creators.buscaAnexosDetalhesPrestacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAnexosDetalhesPrestacaoErro(error)))
    }
}

const buscaAnexosDetalhesPrestacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAnexosDetalhesPrestacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaAnexosDetalhesPrestacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.anexosDetalhesPrestacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ANEXOS_DETALHES_PRESTACAO_INICIO]: buscaAnexosDetalhesPrestacaoInicio,
    [Types.BUSCA_ANEXOS_DETALHES_PRESTACAO_ERRO]: buscaAnexosDetalhesPrestacaoErro,
    [Types.BUSCA_ANEXOS_DETALHES_PRESTACAO_SUCESSO]: buscaAnexosDetalhesPrestacaoSucesso,
})
